module.exports = __webpack_public_path__ + "static/img/アセット 22@2x.b007aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 22@2x.png
// module id = pPDi
// module chunks = 1